'use strict';

const FilterUtil = {
    projectMatchesFilter: function(nameFilter='', tagFilter='', tagsWithMatchingDesc={}, project) {
        if (!!nameFilter) {
            if (project.name.toLowerCase().indexOf(nameFilter.toLowerCase()) < 0) return false;
        }

        if (!!tagFilter) {
            if (!project.integration_tags) return false;

            let found = false;
            for (let i = 0; i < project.integration_tags.length; ++i) {
                const tagRecord = project.integration_tags[i];
                if (tagRecord.tag.indexOf(tagFilter) >= 0 || tagsWithMatchingDesc[tagRecord.id]) {
                    found = true;
                    break;
                }

            }

            if (!found) {
                return false;
            }
        }

        return true;
    },

    activityMatchesFilter: function(nameFilter='', tagFilter='', tagsWithMatchingDesc={}, activity) {
        if (!!nameFilter) {
            if (activity.meta_data.title.toLowerCase().indexOf(nameFilter.toLowerCase()) < 0) return false;
        }

        if (!!tagFilter) {
            if (!activity.integration_tags) return false;

            let found = false;
            for (let i = 0; i < activity.integration_tags.length; ++i) {
                const tagRecord = activity.integration_tags[i];
                if (tagRecord.tag.indexOf(tagFilter) >= 0 || tagsWithMatchingDesc[tagRecord.id]) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                return false;
            }
        }

        return true;
    },

    shortCourseMatchesFilter: function(nameFilter='', tagFilter='', tagsWithMatchingDesc={}, shortCourse) {
        if (!!nameFilter) {
            if (shortCourse.title.toLowerCase().indexOf(nameFilter.toLowerCase()) < 0) return false;
        }

        if (!!tagFilter) {
            if (!shortCourse.integration_tags) return false; // NOTE: currently not supported

            let found = false;
            for (let i = 0; i < shortCourse.integration_tags.length; ++i) {
                const tagRecord = shortCourse.integration_tags[i];
                if (tagRecord.tag.indexOf(tagFilter) >= 0 || tagsWithMatchingDesc[tagRecord.id]) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                return false;
            }
        }

        return true;
    },

    folderMatchesFilter: function(nameFilter='', tagFilter='', folder) {
        if (!!tagFilter) return false; // tags not associated with folders. if any tag filter present, necessarily a mismatch

        if (!!nameFilter) {
            if (folder.name.toLowerCase().indexOf(nameFilter.toLowerCase()) < 0) return false;
        }

        // no tags attached to folders
        return true;
    },

    // optimization: generate an object of the format { [tagId1]: true, ... } 
    // where tag id keys are integration tags where this.props.tagFitler in contained in the tag description
    // used with projectMatchesFilter() and activityMatchesFilter() as tagsWithMatchingDesc param for quicker filtering
    getTagsWithMatchingDescObj: function(tagFilter='', tagArray=[]) {
        let tagsWithMatchingDesc = {};
        if (!tagFilter) {
            return tagsWithMatchingDesc;
        }

        const tagFilterToLower = tagFilter.toLowerCase();
        for (let i = 0; i < tagArray.length; ++i) {
            const tagDescToLower = !!tagArray[i].description ? tagArray[i].description.toLowerCase() : null;
            if (!!tagDescToLower && tagDescToLower.indexOf(tagFilterToLower) >= 0) {
                tagsWithMatchingDesc[tagArray[i].id] = true;
            }
        }

        return tagsWithMatchingDesc;
    }
};

module.exports = FilterUtil;